export type Route = {
    q?: string;
} & Record<string, string>;

export const GroupToPrefixMap = {
    PRODUCT: "p",
    CONTENT: "c",
} as const;
export type SearchRoutePrefix =
    (typeof GroupToPrefixMap)[keyof typeof GroupToPrefixMap];

export const TypeToRoutePropertyMap = {
    HITS_PER_PAGE: ["hitsPerPage"],
    PAGINATION: ["page"],
    SORT: ["sortBy"],
} as const;
export type RouteProperty =
    (typeof TypeToRoutePropertyMap)[keyof typeof TypeToRoutePropertyMap][number];
